import { useState } from "react";
import { Eye } from "lucide-react";
import { exitPreview } from "@/lib/catalog";
import { API_URL as API } from "@/lib/backend";


export const PreviewBanner = () => {
  const [state, setState] = useState("idle");
  const publish = async () => {
    setState("busy");
    try {
      const res = await fetch(`${API}/admin/publish`, { method: "POST", credentials: "include" });
      if (!res.ok) throw new Error();
      setState("done");
    } catch {
      setState("error");
    }
  };
  return (
    <div data-testid="preview-banner" className="bg-bordeaux px-4 py-2.5 text-white">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-x-4 gap-y-2 text-[13px]">
        <p className="flex items-center gap-2">
          <Eye className="h-4 w-4 shrink-0" />
          {state === "done" ? "Publicado. A loja já mostra esta versão." : "Pré-visualização: inclui alterações por publicar. Só tu vês esta versão."}
          {state === "error" && <span className="font-semibold"> Não foi possível publicar.</span>}
        </p>
        <div className="flex items-center gap-2">
          <a href="/admin" data-testid="preview-back-to-panel" className="min-h-[36px] rounded-full border border-white/40 px-3 py-1.5 hover:bg-white/10">Painel</a>
          {state !== "done" && (
            <button type="button" onClick={publish} disabled={state === "busy"} data-testid="preview-publish-button" className="min-h-[36px] rounded-full bg-white px-3 py-1.5 font-semibold text-bordeaux disabled:opacity-60">
              {state === "busy" ? "A publicar..." : "Publicar"}
            </button>
          )}
          <button type="button" onClick={exitPreview} data-testid="preview-exit-button" className="min-h-[36px] rounded-full px-3 py-1.5 underline-offset-2 hover:underline">Sair</button>
        </div>
      </div>
    </div>
  );
};
